import { Outlet } from 'react-router-dom';
import { OrganizationContextProvider } from './organization.context';

export default function OrganizationLayout() {
  return (
    <OrganizationContextProvider>
      <Outlet />
    </OrganizationContextProvider>
  );
}
